import { Component, Input } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
    selector: 'sentry-skeleton-loader',
    templateUrl: './skeleton-loader.component.html',
    standalone: true,
    imports: [NgxSkeletonLoaderModule]
})
export class SkeletonLoaderComponent {
  @Input() count = 5;
}
